import { adminHttpClient } from '../../commons/adminHttpClient'
import { LegalDocument } from '../../../domain/legalDocuments/legalDocuments'

const getEELegalDocuments = (planPeriodId: string): Promise<LegalDocument[]> => {
  return adminHttpClient.get(`/EEDashboard/EELegalDocument?planPeriodId=${planPeriodId}`)
}

export default getEELegalDocuments

export interface SummaryOfBfBenefitDocuments {
  planPeriodId?: string
}

export const getSummaryOfBenefitLegalDocuments = (data: SummaryOfBfBenefitDocuments) => {
  return adminHttpClient.get('/EEDashboard/EELegalDocumentsSummaryOfBenefitAndCoverage', data)
}
